import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { getAccessToken, getRefreshToken } from "./authSession";

const initialUser = {
  access: getAccessToken(),
  refresh: getRefreshToken(),
  userId: "",
  full_name: "",
  email: "",
  is_staff: false,
  is_superuser: false,
  is_invitee: false,
  logging_date: null,
};

const userStore = (set) => ({
  user: initialUser,

  setUser: (value = {}) =>
    set((state) => ({
      user: {
        ...state.user,
        ...value,
        logging_date: new Date(),
      },
    })),

  clearUser: () => set({ user: initialUser }),
});

export const useStore = create(
  devtools(
    persist(userStore, {
      name: "user-store",
      partialize: (state) => ({
        user: {
          ...state.user,
          access: "",
          refresh: "",
        },
      }),
      merge: (persisted, current) => ({
        ...current,
        ...(persisted || {}),
        user: {
          ...current.user,
          ...((persisted || {}).user || {}),
          access: getAccessToken(),
          refresh: getRefreshToken(),
        },
      }),
    })
  )
);
